import { ReactComponent as CheckMark } from "../assets/icons/Check.svg";

const ListItem = ({ children }) => (
  <li className="flex items-start justify-start space-x-4">
    <CheckMark className="flex-shrink-0 mt-1 h-4 w-4 text-secondary" />
    <p className="text-darkgray text-sm">{children}</p>
  </li>
);

const Agreement = () => (
  <div className="p-8 bg-white text-justify">
    <h1 className="mb-8 text-secondary text-2xl text-center font-semibold">
      Terms and Conditions
    </h1>

    <p className="mt-3 text-darkgray text-sm">
      <b>
        PLEASE READ THE FOLLOWING AGREEMENT CAREFULLY. THIS PARTICIPANT SERVICE
        AGREEMENT (“AGREEMENT”) IS A LEGAL CONTRACT BETWEEN YOU (HEREINAFTER
        REFERRED TO AS “YOU”, “YOUR” OR “PARTICIPANT”) AND GLOBAL CLOUD CAYR
        PRIVATE LIMITED, (HEREINAFTER REFERRED TO AS “WE”, “US”, “OUR” OR
        “SERVICE PROVIDER”) WITH ITS REGISTERED OFFICE AT S-436, BASEMENT,
        GREATER KAILASH PART-1, SOUTH DELHI, NEW DELHI, DELHI, INDIA 110048.
      </b>
    </p>
    <p className="mt-3 text-darkgray text-sm">
      <b>
        THIS AGREEMENT CONTAINS IMPORTANT INFORMATION IN RELATION TO THE RIGHTS
        AND OBLIGATIONS, AS WELL AS THE LIMITATIONS AND EXCLUSIONS GOVERNING THE
        RELATIONSHIP BETWEEN THE PARTICIPANT AND THE SERVICE PROVIDER. THIS
        AGREEMENT IS ENTERED INTO AS OF THE DATE YOU ACCEPT THESE TERMS.
      </b>
    </p>
    <p className="mt-3 text-darkgray text-sm">
      <b>
        BY CLICKING
        <span className="font-semibold">"I AGREE,"</span> YOU ACKNOWLEDGE THAT
        YOU HAVE READ, UNDERSTOOD, AND AGREED TO BE BOUND BY THIS AGREEMENT.
      </b>
    </p>
    <p className="mt-3 text-darkgray text-sm">
      The Service Provider and the Participant shall hereinafter be collectively
      referred to as the<span className="font-semibold">“Parties”</span> and
      individually as <span className="font-semibold">“Party”</span>
    </p>
    <p className="mt-3 text-darkgray text-sm">
      <span className="font-semibold">WHEREAS</span> the Participant seeks to
      avail of the hybrid health and wellness management services offered by the
      Service Provider.
    </p>
    <p className="mt-3 text-darkgray text-sm">
      In consideration of the mutual covenants contained herein, the Parties to
      the Agreement agree as follows:
    </p>
    <ol className="list-decimal pl-5">
      <li className="mt-5 text-darkgray">
        DEFINITIONS AND INTERPRETATION
        <ol className="list-disc pl-5">
          <li className="mt-3 text-darkgray">
            Definitions
            <p className="mt-3 text-darkgray text-sm">
              In addition to the terms defined elsewhere in this Agreement,
              capitalised terms shall have the following meanings attributed to
              them as under:
            </p>
            <ul className="mt-3 space-y-4">
              <ListItem>
                <span className="font-semibold">“Add-On Services”</span>refer to
                the optional or supplementary healthcare services beyond the
                scope of services included in the Care Plan or provided by third
                parties, which shall be available on a pay-per-use basis. These
                shall include but not be limited to ambulance services,
                specialist consultations, sessions with allied healthcare
                professionals such as physical therapist and/or speech
                therapist, tests and diagnostic scans. For services provided by
                the Service Provider, payments shall be made by the Participant
                to the Service Provider, and for services provided by third
                parties, payments shall be made by the Participant directly to
                the third parties
              </ListItem>
              <ListItem>
                <span className="font-semibold">"Care Plan" </span>refers to the
                personalized healthcare plan created for the Participant, which
                may include details including but not limited to health
                monitoring, treatment procedures, lifestyle recommendations and
                payment terms and schedules. It may include monitoring
                schedules, recommended treatments, review frequency, medication
                protocols, dietary guidelines, exercise regimens, and necessary
                lifestyle modifications. Designed in consultation with medical
                professionals, it shall be tailored based on the Participant’s
                medical history, current health status, ongoing treatments, and
                identified risk factors. The Care Plan may be updated
                periodically based on medical necessity, advancements in
                treatment, changes in the Participant’s health, or modifications
                in payment terms; as further detailed in Clause 8 of this
                Agreement.
              </ListItem>
              <ListItem>
                <span className="font-semibold">"Emergency Assistance" </span>
                comprises the support services provided during urgent medical
                situations, including coordination with hospitals and ambulance
                providers; as further detailed in Clause 7 of this Agreement.
              </ListItem>
              <ListItem>
                <span className="font-semibold">“Privacy Policy”</span>
                refers to the privacy policy of the Service Provider, available
                on the online platform of the Service Provider, as amended from
                time to time
              </ListItem>
              <ListItem>
                <span className="font-semibold">"Registration Fee(s)"</span>{" "}
                shall mean the one-time fee payable by the Participant for
                enrollment in the services offered by the Service Provider. The
                exact amount of the Registration Fees shall be communicated to
                the Participant prior to the commencement of the onboarding
                process. The Registration Fee shall be adjusted against the
                monthly fees payable to the Service Provider by the Participant
                as per the agreed Care Plan within a reasonable period of time.
              </ListItem>
              <ListItem>
                <span className="font-semibold">“Terms of Service”</span> refers
                to the terms of service of the Service Provider, available on
                the online platform of the Service Provider, as amended from
                time to time
              </ListItem>
            </ul>
          </li>
          <li className="mt-5 text-darkgray">
            Interpretation <br />
            <p className="text-darkgray text-sm mt-2">In this Agreement:</p>
            <ul className="mt-3 space-y-4">
              <ListItem>
                the words “herein,” “hereunder” and “hereof” refer to this
                Agreement, taken as a whole, and not to any particular provision
                of this Agreement; the words “including,” “include”, “includes”,
                “comprise”, “comprising”, “such as”, “encompass” (and words of
                similar mean) shall be construed to mean “without limiting the
                generality of the foregoing” or “without limitation” or “inter
                alia”;
              </ListItem>
              <ListItem>
                all references to a given agreement, instrument or other
                document shall be a reference to that agreement, instrument or
                other document as modified, amended, supplemented and restated
                through the date as of which such reference is made;
              </ListItem>
              <ListItem>
                references to any legislation or to any provision of any
                legislation shall include any modification or re-enactment of
                that legislation or any legislative provision substituted
                therefore, and all rules, regulations, directions, notifications
                and circulars issued under such legislation or provision;
              </ListItem>
              <ListItem>
                all agreements, consents, approvals and notices to be made or
                given under this Agreement including modifications thereof, must
                be given expressly and in writing;
              </ListItem>
              <ListItem>
                “in writing” includes any communication made by letter, email,
                WhatsApp message, SMS, or fax
              </ListItem>
              <ListItem>
                reference to singular shall include the plural, and vice versa;
              </ListItem>
              <ListItem>
                any references to the masculine, the feminine and the neuter
                shall include each other;
              </ListItem>
              <ListItem>
                the recitals, annexure, exhibits and schedules form an integral
                part of this Agreement and shall have the same force and effect
                as if expressly set out in the body of this Agreement, and any
                reference to this Agreement shall include any recitals,
                exhibits, annexure and schedules to it. Any references to
                clause, schedules or recitals or annexures are to clauses of,
                schedules to, recitals to, or annexure in this Agreement. Any
                references to parts or paragraphs are, unless otherwise stated,
                references to parts or paragraphs of the schedule in which the
                reference appears;
              </ListItem>
              <ListItem>
                titles and headings to clauses or schedules herein are inserted
                for convenience of reference only, and are not intended to be a
                part of or to affect the meaning or interpretation of this
                Agreement;
              </ListItem>
              <ListItem>
                the expression “this clause/the clause” shall, unless followed
                by reference to a specific provision, be deemed to refer to the
                whole Clause (not merely the sub-clause, paragraph or other
                provision) in which the expression occurs;
              </ListItem>
              <ListItem>
                the Parties acknowledge that they have read and understood the
                terms of this Agreement. No provision of this Agreement shall be
                interpreted in favour of, or against any Party by reason of the
                extent to which such Party participated in the drafting hereof
                or by reason of the extent to which any such provision is
                inconsistent with any prior draft hereof. Any rule of statutory
                interpretation interpreting agreements against a party primarily
                responsible for drafting the agreement shall not be applicable
                to this Agreement; and
              </ListItem>
            </ul>
          </li>
        </ol>
      </li>
      <li className="mt-5 text-darkgray">
        SCOPE OF SERVICES
        <ol className="list-disc pl-5 mt-2">
          <li>
            The Service Provider’s healthcare model is structured into the
            following key modalities of treatment:
            <ol className="list-[lower-roman] pl-5">
              <li className="mt-2 text-darkgray">
                Telehealth Services:
                <ul className="mt-3 space-y-4">
                  <ListItem>
                    <i>Virtual Consultations:</i> The Service Provider offers
                    virtual consultations, enabling Participants to access
                    medical advice from doctors, nurses, specialists, and health
                    coaches through third party telemedicine / communication
                    platforms or the online platform of the Service Provider, as
                    the case may be
                  </ListItem>
                  <ListItem>
                    <i> Remote Monitoring:</i> Remote monitoring is integrated
                    into the telehealth service, utilizing a third party
                    telemedicine / communication platforms or the online
                    platform of the Service Provider, as the case may be, remote
                    monitoring devices and/or wearable devices, as required by
                    the Participant, that provide tracking of health parameters
                    to facilitate continuous monitoring and timely interventions
                  </ListItem>
                  <ListItem>
                    <i> Health Education:</i> The Service Provider provides
                    health education through informational content designed to
                    promote preventive healthcare measures and effective chronic
                    disease management.
                  </ListItem>
                </ul>
              </li>
              <li className="mt-5 text-darkgray">
                In-Person Services:
                <ul className="mt-3 space-y-4">
                  <ListItem>
                    <i>Home Visits:</i> Participants requiring physical
                    assessments or hands-on medical attention can avail
                    themselves of the Service Provider’s in-person services.
                    Home visits are offered, where qualified doctors, nurses,
                    and allied healthcare professionals provide in-home medical
                    care, including diagnostics, assessments, and treatment as
                    required.
                  </ListItem>
                  <ListItem>
                    <i> Local Labs and Diagnostic Centres:</i> The Service
                    Provider has partnered with local labs and diagnostic
                    centres to extend its services, allowing Participants to
                    undergo diagnostic tests, routine check-ups, and follow-up
                    consultations at designated healthcare facilities.
                  </ListItem>
                </ul>
              </li>
            </ol>
          </li>
          <li className="mt-5 text-darkgray">
            Subject to the Care Plan and/or Add-On Services subscribed by the
            Participant, the Service Provider offers a comprehensive range of
            healthcare services, including but not limited to the following:
            <ul className="mt-3 space-y-4">
              <ListItem>
                <span className="font-semibold">Preventative Care:</span>{" "}
                Preventive health management services provided by the Service
                Provider focus on regular assessments, lifestyle
                recommendations, and educational initiatives aimed at fostering
                long-term well-being
              </ListItem>
              <ListItem>
                <span className="font-semibold">Chronic Care: </span> For
                individuals with chronic conditions, the Service Provider
                provides medical attention, focusing on managing long-term,
                ongoing health conditions.
              </ListItem>
              <ListItem>
                <span className="font-semibold">Acute Care:</span> For
                individuals with acute conditions, the Service Provider supplies
                short-term monitoring and support following any sudden illness
                or injury, and post-hospitalization recovery support upon
                discharge at the Participant’s place of residence.
              </ListItem>
              <ListItem>
                <span className="font-semibold">Emergency Care:</span> Emergency
                assistance is extended to facilitate hospital admissions and
                ambulance coordination during medical crises.
              </ListItem>
            </ul>
          </li>
          <li className="mt-5 text-darkgray">
            Subject to the Care Plan and/or Add-On Services subscribed to by the
            Participant, the Service Provider shall offer a diverse range of
            services from medical and allied healthcare professionals.
          </li>
          <li className="mt-5 text-darkgray">
            The scope of services for the Participant shall be detailed in the
            Care Plan, and the Participant agrees that it may be amended
            periodically to accommodate the Participant’s needs and healthcare
            requirements.
          </li>
        </ol>
      </li>
      <li className="mt-5 text-darkgray">
        PARTICIPANT RESPONSIBILITIES
        <ul className="mt-3 space-y-4">
          <ListItem>
            The Participant is required to provide accurate and complete medical
            history, ensuring that the Service Provider has a comprehensive
            understanding of pre-existing conditions, ongoing treatments, and
            relevant health concerns. The details of the Participant onboarding
            process, including registration requirements, eligibility criteria,
            and initial health assessments, shall be provided to the Participant
            at the time of onboarding.
          </ListItem>
          <ListItem>
            The Participant must adhere to the prescribed Care Plan, following
            medical and lifestyle recommendations as advised by the Service
            Provider professionals.
          </ListItem>
          <ListItem>
            During home visits, the Participant must ensure availability at the
            scheduled time and cooperate with healthcare professionals to
            facilitate effective treatment.
          </ListItem>
          <ListItem>
            When using telemedicine services, the Participant is responsible for
            ensuring a stable internet connection and adhering to scheduled
            virtual consultations.
          </ListItem>{" "}
          <ListItem>
            Participants must maintain respectful communication with all the
            Service Provider’s personnel, fostering a professional and
            supportive healthcare environment.
          </ListItem>
          <ListItem>
            By agreeing to the terms of this Agreement, the Participant also
            expressly agrees to be bound by the Terms of Service, Privacy
            Policy, and any other policies of the Service Provider as provided
            on the official website or mobile application of the Service
            Provider. The Participant acknowledges that these policies may be
            updated from time to time and agrees to review and comply with the
            latest versions as and when published.
          </ListItem>
          <ListItem>
            The Participant acknowledges and agrees that the Service Provider’s
            services may facilitate the submission of content provided by the
            Participant to third-party service providers, either manually at the
            Participant’s direction or automatically as per the Participant’s
            subscription model. The Participant represents and warrants that all
            submitted content is accurate, complete, up-to-date, and compliant
            with applicable laws, rules, and regulations. For the purposes of
            this clause, "content" includes, but is not limited to, user profile
            information made publicly available by the Participant, data
            collected by the Service Provider (such as statistics and
            measurements), and wellness-related information generated through
            the use of the Service Provider’s services.
          </ListItem>
          <ListItem>
            The Participant hereby agrees not to: (i) provide false or
            misleading information that may cause damage to the Service Provider
            or any third party; (iii) submit material or content that is
            unlawful, obscene, defamatory, libelous, threatening, pornographic,
            harassing, hateful, racially or ethnically offensive, or encourages
            conduct that would be considered a criminal offense, give rise to
            civil liability, violate any law, or is otherwise inappropriate;
            (iv) post advertisements or solicitations of business; or (v)
            impersonate another person.
          </ListItem>{" "}
          <ListItem>
            The Participant hereby acknowledges and agrees that in addition to
            the limitations and restrictions set forth in this Agreement, the
            use of artificial intelligence and technology (“AI” or “AI
            Technology”) and its generated output have inherent limitations,
            including but not limited to: (i) potential errors, misleading
            information, and lack of accuracy or reliability; (ii) reliance on
            predefined rules and algorithms, leading to repetitive or formulaic
            content and an inability to generate original ideas; (iii)
            difficulty in understanding language nuances, including slang,
            idioms, and cultural references, which may result in out-of-context
            or nonsensical output; (iv) lack of emotions, preventing AI from
            conveying empathy or emotional depth in its output; (v) risk of
            perpetuating biases present in training data, potentially leading to
            discriminatory or offensive output; (vi) challenges in handling
            complex tasks requiring reasoning, judgment, or decision-making;
            (vii) dependence on large datasets for training, where poor-quality
            or biased data can negatively impact output accuracy and quality;
            and (viii) absence of the personal touch inherent in human-created
            content, making AI-generated output feel cold or impersonal. The
            Participant hereby agrees to exercise independent judgment and
            discretion before relying on or using any AI-generated output. The
            output is for informational purposes only and is not a substitute
            for advice from a qualified professional. The Service Provider
            assumes no liability for any consequences arising from the use of AI
            Technology or its output
          </ListItem>
        </ul>
      </li>
      <li className="mt-5 text-darkgray">
        TELECONSULTATION CONSENT
        <ul className="mt-3 space-y-4">
          <ListItem>
            By utilizing the telehealth services provided by the Service
            Provider, the Participant acknowledges and accepts the inherent
            limitations associated with virtual consultations. The Participant
            understands that teleconsultation services do not involve physical
            examinations, in-person diagnostic procedures, or hands-on
            assessments, which may be critical for certain medical evaluations
            and treatments. The Participant further acknowledges that virtual
            consultations are intended for preliminary medical advice, follow-up
            discussions, routine health monitoring, and chronic disease
            management but may not always be a suitable substitute for direct
            clinical interactions.
          </ListItem>
          <ListItem>
            The Participant consents to the Service Provider recording virtual
            consultations for quality control, training, regulatory compliance,
            and documentation purposes. Such recordings shall be securely stored
            and accessed only by authorized personnel. The Service Provider
            hereby further agrees that such recordings shall not be disclosed to
            unauthorized third parties without explicit consent unless required
            by law.
          </ListItem>
          <ListItem>
            The Participant understands that medical recommendations made during
            teleconsultations are based on the information provided by the
            Participant, including symptoms, medical history, and diagnostic
            reports shared electronically. As telehealth services rely on remote
            data inputs, there may be limitations in diagnosis, prescription,
            and treatment efficacy compared to in-person consultations. The
            Participant agrees that any medical advice or recommendations
            provided via teleconsultation should be followed up with in-person
            medical evaluations where required, particularly in cases involving
            acute symptoms, emergency conditions, complex diagnoses, or
            specialized treatment needs.
          </ListItem>
          <ListItem>
            The Service Provider shall take all reasonable measures to ensure
            that telehealth services are provided by qualified healthcare
            professionals using secure and reliable technology. However, the
            Participant understands that the Service Provider shall not be held
            liable for any limitations or inaccuracies resulting from technical
            issues, connectivity failures, incorrect or incomplete medical
            information provided by the Participant, or the inherent constraints
            of virtual healthcare delivery.
          </ListItem>{" "}
          <ListItem>
            The Participant agrees to adhere to all instructions regarding
            teleconsultations, including ensuring a stable internet connection,
            using a private and secure location, and providing accurate and
            complete medical details. The Participant further acknowledges that
            telehealth services may not be suitable for urgent or
            life-threatening medical conditions and agrees to seek immediate
            emergency medical attention in such scenarios rather than relying
            solely on virtual consultations.
          </ListItem>
        </ul>
      </li>
      <li className="mt-5 text-darkgray">
        DATA PRIVACY AND MEDICAL RECORDS
        <ul className="mt-3 space-y-4">
          <ListItem>
            The Service Provider ensures the secure storage of all medical
            records and health data, which will only be accessed by authorized
            personnel of the Service Provider for treatment and service
            enhancement purposes. The Participant's medical data may be shared
            with accredited third-party providers, including diagnostic
            laboratories, telemedicine / communications / technology platforms,
            providers of remote patient monitoring devices, and emergency
            response teams, for service fulfillment. By availing services, the
            Participant grants explicit consent for the Service Provider to use
            their health data in compliance with applicable data protection
            laws, ensuring confidentiality and responsible handling of personal
            medical information.
          </ListItem>
          <ListItem>
            The Service Provider is committed to ensuring the secure storage,
            management, and confidentiality of all medical records and health
            data provided by the Participant. All medical data shall be stored
            in a secure digital or physical format, accessible only to
            authorized personnel of the Service Provider, and utilized strictly
            for treatment planning, service improvement, and regulatory
            compliance. The Participant’s medical data shall not be accessed,
            disclosed, or shared with any unauthorized individuals or entities
            without the express consent of the Participant, except as required
            by law.
          </ListItem>
          <ListItem>
            The Service Provider is committed to ensuring that the medical
            records, including consultation history, diagnostic reports,
            treatment plans, and health tracking data from remote patient
            monitoring devices, are maintained and updated as per industry best
            practices. The Service Provider is committed to implementing
            cybersecurity measures, including encryption protocols, firewalls,
            and secure access controls, to prevent unauthorized access, data
            breaches, or loss of sensitive health information.
          </ListItem>
          <ListItem>
            The Participant acknowledges and agrees that their medical data may
            be shared with accredited third- party service providers, including
            but not limited to diagnostic laboratories, telemedicine /
            communication / technology platforms, providers of remote patient
            monitoring devices, emergency response teams, and specialist
            consultants, solely for the purpose of delivering the healthcare
            services outlined in this Agreement. The Service Provider shall
            ensure that such third-party providers adhere to applicable data
            protection regulations and maintain strict confidentiality in
            handling Participant information.
          </ListItem>{" "}
          <ListItem>
            By availing services under this Agreement, the Participant grants
            explicit consent to the Service Provider to collect, process, store,
            and share their health data in accordance with applicable data
            protection laws, including but not limited to the Information
            Technology Act, 2000, and any subsequent amendments, as well as the
            Digital Personal Data Protection Act, 2023, if applicable. The
            Participant retains the right to request access to their medical
            records, seek corrections where necessary, and withdraw consent for
            further data processing, subject to legal and contractual
            obligations.
          </ListItem>
          <ListItem>
            In the event of a suspected data breach or unauthorized access, the
            Service Provider shall undertake immediate remedial measures,
            including notifying affected Participants and implementing
            corrective security enhancements. The Service Provider shall not be
            liable for any data loss or compromise arising from unforeseen
            cyberattacks, Participant negligence, or third-party service
            provider breaches beyond its reasonable control.
          </ListItem>{" "}
          <ListItem>
            The Participant acknowledges that electronic health records may be
            stored for a legally prescribed period, post which the Service
            Provider reserves the right to anonymize or securely dispose of such
            records unless otherwise required by law or regulatory authorities.
          </ListItem>
        </ul>
      </li>
      <li className="mt-5 text-darkgray">
        THIRD-PARTY SERVICE PROVIDERS
        <ul className="mt-3 space-y-4">
          <ListItem>
            The Service Provider collaborates with third-party service providers
            to deliver diagnostic, telemedicine, and healthcare monitoring
            solutions, and emergency response services. While the Service
            Provider takes all reasonable measures to ensure the reliability and
            professionalism of these providers, it shall not be held liable for
            any errors, delays, service interruptions, deficiencies,
            inaccuracies, or malpractice in services rendered by third parties.
            This includes, but is not limited to, potential inaccuracies arising
            from remote patient monitoring devices which may have a margin of
            error.
          </ListItem>
          <ListItem>
            The Participant acknowledges that all the third-party providers,
            including but not limited to the third party service providers as
            mentioned in Clause 6.1, engaged by the Service Providers operate
            independently from the Service Provider and that the Service
            Provider does not exercise control over the clinical decisions,
            service delivery timelines, equipment calibration, or treatment
            methodologies employed by such providers. Any concerns, disputes, or
            claims arising from services rendered by third- party providers
            shall be addressed directly with the respective provider, and the
            Service Provider shall not in any way be held responsible to the
            Participant for the same.
          </ListItem>
          <ListItem>
            While the Service Provider endeavors to work only with accredited
            and qualified third-party service providers, it does not warrant or
            guarantee the effectiveness, safety, or outcomes of the services
            provided by such entities. The Participant is responsible for
            reviewing and understanding the terms and conditions of any
            third-party service providers engaged through the Service Provider’s
            platform.
          </ListItem>
          <ListItem>
            In the case of diagnostic services, including but not limited to
            laboratory tests and imaging services, the accuracy of results may
            be influenced by various factors beyond the Service Provider’s
            control. The Participant agrees that the Service Provider shall not
            be liable for any medical decisions made based on third-party
            diagnostic results, telemedicine consultations, or treatment
            interventions facilitated through third-party collaborations.
          </ListItem>
        </ul>
      </li>
      <li className="mt-5 text-darkgray">
        EMERGENCY ASSISTANCE
        <ul className="mt-3 space-y-4">
          <ListItem>
            The Service Provider facilitates emergency assistance by
            coordinating hospital admissions and arranging ambulance services
            for Participants experiencing critical health situations. The
            Service Provider shall act as an intermediary between the
            Participant and emergency response teams, ensuring that necessary
            logistical arrangements are made promptly. However, the Service
            Provider does not directly provide emergency medical treatment or
            guarantee hospital and/or ambulance availability and thus shall not
            in any way be held responsible to the Participant for the same.
          </ListItem>
          <ListItem>
            The Participant acknowledges that the effectiveness of emergency
            assistance is contingent upon external factors such as hospital
            capacity, response times of ambulance services, traffic conditions,
            and the geographic location of the emergency. The Service Provider
            shall make reasonable efforts to secure the most efficient response
            but shall not be liable for any delays, denials, or complications
            arising during the emergency coordination process.
          </ListItem>
          <ListItem>
            The Service Provider shall maintain a network of partnered
            hospitals, ambulance providers, and medical professionals to
            facilitate emergency care. However, the selection of a hospital or
            emergency service provider shall be subject to availability, medical
            necessity, and the Participant’s preference where possible. In cases
            where the Participant is unable to make a decision, the Service
            Provider reserves the right to act in good faith and select the most
            appropriate facility for medical attention.
          </ListItem>
          <ListItem>
            The Participant understands that while the Service Provider ensures
            prompt action in coordinating emergency services, it shall not be
            responsible for medical decisions made by attending healthcare
            professionals, hospital treatment outcomes, or any post-emergency
            complications. The Participant releases the Service Provider from
            any liability related to the quality of care administered by
            third-party emergency service providers or medical institutions.
          </ListItem>{" "}
          <ListItem>
            If the Participant requires emergency transportation, the Service
            Provider shall coordinate with accredited ambulance providers. Costs
            associated with ambulance transport, hospital admissions, and any
            medical procedures undertaken shall be the sole responsibility of
            the Participant.
          </ListItem>
          <ListItem>
            Additionally, the Participant agrees to provide the Service Provider
            with updated emergency contact details, relevant medical history,
            and any necessary authorizations that may assist in expediting
            emergency response efforts. In circumstances where the Participant
            is incapacitated and unable to provide consent, the Service Provider
            shall act in accordance with previously obtained instructions or in
            consultation with the Participant’s emergency contacts.
          </ListItem>{" "}
          <ListItem>
            The Service Provider retains the right to modify or discontinue
            emergency assistance services at its discretion based on operational
            feasibility, regulatory requirements, or changes in its partnerships
            with emergency service providers. The Participant shall be notified
            in advance of any significant modifications to the emergency
            assistance program.
          </ListItem>
        </ul>
      </li>
      <li className="mt-5 text-darkgray">
        CUSTOMIZED CARE PLAN & CONSENT
        <ul className="mt-3 space-y-4">
          <ListItem>
            Each Participant shall receive a tailored Care Plan, designed based
            on their medical history, current health status, ongoing treatments,
            and identified risk factors. The Care Plan will detail the
            monitoring schedule, recommended treatments, review frequency,
            medication protocols, dietary guidelines, exercise regimens, and
            necessary lifestyle modifications to support the Participant’s
            health and well- being. The Care Plan shall serve as a comprehensive
            roadmap for preventive and therapeutic healthcare management.
          </ListItem>
          <ListItem>
            The Service Provider shall collaborate with medical professionals,
            including general practitioners, specialists, and allied health
            professionals, to ensure that the Care Plan aligns with best medical
            practices and evidence-based treatment approaches. In cases where
            the Participant has an existing healthcare provider, the Service
            Provider shall endeavor to work in coordination with such providers,
            ensuring continuity of care and avoiding conflicts in medical advice
            or treatment strategies.
          </ListItem>
          <ListItem>
            Any modifications or updates to the Care Plan shall be communicated
            to the Participant in a timely manner and will only be implemented
            upon obtaining their explicit consent. Adjustments may be necessary
            due to changes in the Participant’s medical condition, response to
            treatment, advancements in medical guidelines, or emerging health
            concerns. The Participant retains the right to seek clarification
            regarding any proposed changes before providing consent.
          </ListItem>
          <ListItem>
            Continuous assessments will be conducted to ensure the ongoing
            effectiveness of the Care Plan. This shall include regular health
            check-ins, follow-up consultations, progress tracking using remote
            patient monitoring devices, and periodic laboratory investigations
            where applicable. The Participant agrees to actively engage in this
            process, including attending scheduled consultations, following
            prescribed medical advice, and promptly reporting any adverse
            reactions or concerns regarding their health status.
          </ListItem>{" "}
          <ListItem>
            The Service Provider shall maintain accurate and updated records of
            all Care Plans and modifications made over time. Such records shall
            be securely stored and accessible to authorized healthcare
            professionals involved in the Participant’s treatment. The
            Participant may request access to their records and shall be
            entitled to seek second opinions where necessary.
          </ListItem>
          <ListItem>
            In the event of an emergency or a sudden deterioration of the
            Participant’s health, the Service Provider reserves the right to
            make temporary and immediate adjustments to the Care Plan in
            consultation with medical professionals, with the primary objective
            of safeguarding the Participant’s health. Any such changes will be
            formally reviewed and discussed with the Participant as soon as
            reasonably possible.
          </ListItem>
        </ul>
      </li>
      <li className="mt-5 text-darkgray">
        FEES AND PAYMENT
        <ul className="mt-3 space-y-4">
          <ListItem>
            Services under this Agreement are provided on a subscription basis
            (covering a package of included services as per the Care Plan) and a
            pay-per-use basis (for Add-On Services). Participants are required
            to make payments as per the schedule agreed upon between the
            Participant and the Service Provider during the onboarding process
            and outlined in the Care Plan to ensure uninterrupted service. For
            services provided by the Service Provider, payments shall be made by
            the Participant to the Service Provider, and for services provided
            by third parties, payments shall be made by the Participant directly
            to the third parties.
          </ListItem>
          <ListItem>
            Failure to remit payments within the stipulated time may result in
            the suspension of services until all outstanding dues are cleared.
            Additional charges shall apply for emergency interventions, extended
            consultations, specialized diagnostic services, or any other
            services not covered in the Care Plan. The Participant acknowledges
            that all fees are non-refundable unless explicitly stated otherwise
            under applicable laws.
          </ListItem>
          <ListItem>
            At the time of onboarding, the Participant shall be required to pay
            a Registration Fee. The Service Provider reserves the right to amend
            the applicable Registration Fee at its sole discretion from time to
            time. The Registration Fee shall be adjusted against the monthly
            fees payable to the Service Provider by the Participant for the
            services provided to the Participant as per the agreed Care Plan
            within a reasonable period of time.
          </ListItem>
          <ListItem>
            A Care Plan, customized based on the information provided by the
            Participant and their specific needs, shall be designed by the
            medical team and be presented to the Participant along with the
            subscription plan offered by the Service Provider within 2 (two) to
            3 (three) weeks from the date of payment of the Registration Fees by
            the Participant.
          </ListItem>{" "}
          <ListItem>
            The Service Provider reserves the right to revise the pricing
            structure periodically, with prior notification to the Participant.
            Any modifications in pricing shall be communicated in writing or
            through electronic notifications, and continued use of services
            following such changes shall constitute acceptance of the revised
            payment terms.
          </ListItem>
        </ul>
      </li>
      <li className="mt-5 text-darkgray">
        LIMITATION OF LIABILITY AND INDEMNITY
        <ul className="mt-3 space-y-4">
          <ListItem>
            The Service Provider offers healthcare facilitation services and
            does not guarantee specific medical outcomes, improvements in health
            conditions, or the effectiveness of treatments provided through its
            network of healthcare professionals, facilities, and third-party
            providers. The Participant acknowledges that healthcare services
            inherently carry risks and that medical results may vary based on
            individual conditions, compliance with prescribed treatments, and
            other factors beyond the control of the Service Provider.
          </ListItem>
          <ListItem>
            The Participant hereby acknowledge and accept that all the services
            provided by the Service Provider under this Agreement are on a best
            endeavor basis and therefore the Service Provider shall not be held
            liable to the Participant or any third party for medical negligence,
            errors, omissions, delays, misdiagnoses, or malpractice committed by
            independent third-party service providers, including but not limited
            to diagnostic centers, telemedicine platform providers, specialist
            consultants, laboratories, hospitals, or emergency response teams.
            The Participant agrees that any claims related to such negligence or
            deficiencies shall be pursued directly with the respective
            third-party provider.
          </ListItem>
          <ListItem>
            While the Service Provider takes reasonable measures to verify the
            credentials, qualifications, and service quality of third-party
            providers, it does not assume responsibility for their actions,
            medical decisions, procedural methods, or patient outcomes. With
            respect to third party providers, the Service Provider’s role is
            limited to coordinating access to healthcare services and ensuring
            that Participants receive the necessary guidance and support within
            the scope of its operations.
          </ListItem>
          <ListItem>
            The Participant shall solely be responsible for any content
            submitted or allowed to be collected and the consequences of the
            Service Provider’s usage of such Participant’s content. The
            Participant hereby acknowledges and agrees that the Service Provider
            does not endorse the user's content, and the Service Provider
            expressly disclaims any and all liability in connection with the
            content of the Participant.
          </ListItem>{" "}
          <ListItem>
            The Participant hereby agrees to defend, indemnify, and hold the
            Service Provider, its subsidiaries, affiliates, officers, agents,
            suppliers, employees and partners harmless from and against any
            claims, actions or demands, including, without limitation,
            reasonable legal and accounting fees, arising or resulting from (i)
            the content of the Participant, (ii) the breach of this Agreement,
            (iii) the misuse of the services, or (iv) your violation of
            applicable law. The Service Provider shall provide notice to the
            Participant of any such claim, suit, or proceeding and, at its
            discretion, may agree to assist the Participant at the Participant’s
            expense to defend such claim, suit, or proceeding. The Service
            Provider reserves the right to assume the exclusive defense and
            control of any matter subject to this Clause. In such case, the
            Participant hereby agrees to cooperate with any and all requests of
            the Service Provider to assist in the defense of such matter.
          </ListItem>
          <ListItem>
            In no event shall the Service Provider be liable for indirect,
            incidental, consequential, punitive, or special damages, including
            but not limited to loss of income, medical complications, death of
            any Participant, emotional distress, or any claims arising from
            treatment outcomes. The total liability of the Service Provider,
            under any circumstance, shall be strictly limited to the total
            amount paid by the Participant for services availed in the preceding
            6 (six) months prior to the occurrence of the claim.
          </ListItem>
        </ul>
      </li>
      <li className="mt-5 text-darkgray">
        TERMINATION
        <ul>
          <li className="mt-3 text-darkgray text-sm">
            This Agreement may be terminated by either Party with a minimum of
            30 (thirty) days’ written notice. The Service Provider reserves the
            right to terminate services immediately in cases of non-payment,
            breach of contractual terms, or misuse of services. In the event of
            termination, any pending payments for availed services shall remain
            payable by the Participant. This Agreement shall automatically
            terminate upon the death of the Participant.
          </li>
        </ul>
      </li>
      <li className="mt-5 text-darkgray">
        MISCELLANEOUS
        <ul className="mt-3 space-y-4">
          <ListItem>
            <i>Assignment:</i> This Agreement and the rights and obligations
            arising thereunder and/or in connection therewith is not assignable
            or transferable by the Participant and any attempt to do so shall be
            void.
          </ListItem>
          <ListItem>
            <i>Waiver:</i> No failure to exercise, and no delay in exercising,
            on the part of either Party, any privilege, any power or any rights
            hereunder will operate as a waiver thereof, nor will any single or
            partial exercise of right or power hereunder preclude further
            exercise of any other rights hereunder.
          </ListItem>
          <ListItem>
            <i>Severability:</i> if any term, condition or provision of this
            Agreement shall be adjudicated by any court of competent
            jurisdiction to be unenforceable or invalid, that term, condition or
            provision shall be deleted or eliminated and shall be of no force or
            effect so that this Agreement shall otherwise remain in full force
            and effect as if such term, condition, or provision had not
            originally been contained in this Agreement. Notwithstanding the
            above, in the event of any such deletion/elimination, the Parties
            shall negotiate in good faith in order to agree upon a mutually
            acceptable and satisfactory alternative provision in place of the
            provision so deleted/eliminated.
          </ListItem>
          <ListItem>
            <i>Binding Effect:</i> This Agreement shall be binding upon and
            inure to the benefit of the Parties and their respective permitted
            successors and assigns.
          </ListItem>
          <ListItem>
            <i>Entire Agreement/Amendment:</i> This Agreement sets forth the
            complete agreement of the Parties concerning the subject matter
            hereof and supersedes all prior agreements and understandings
            whether oral or written with respect to such subject matter. No
            claimed oral agreement in respect thereto shall be considered as any
            part hereof. This Agreement and the Care Plan should be read
            together as a whole. The Care Plan forms an integral part of this
            Agreement
          </ListItem>
          <ListItem>
            <i>Amendment:</i> The Service Provider shall notify the Participant
            of any amendments through electronic means, including email or
            posting the updated Agreement on its online platform. The
            Participant must review and confirm acceptance of the changes before
            they take effect
          </ListItem>
          <ListItem>
            <i>Force Majeure:</i> The Service Provider shall not be held liable
            for any failure or delay in performing its obligations under this
            Agreement due to causes beyond its reasonable control, including but
            not limited to acts of God, natural disasters, pandemics, epidemics,
            strikes, lockouts, labor disputes, civil disturbances, acts of war
            or terrorism, governmental actions, changes in law or regulations,
            cyber- attacks, technical failures, or power outages. If a force
            majeure event occurs, the Service Provider shall notify the
            Participant and make reasonable efforts to resume services as soon
            as practicable. The Service Provider shall not be obligated to
            provide any refunds, credits, or compensation for services delayed
            or interrupted due to a force majeure event.
          </ListItem>
          <ListItem>
            <i>Counterparts/Facsimiles:</i> This Agreement may be executed in
            one or more counterparts, each of which is an original and all of
            which taken together shall be deemed one and the same instrument
          </ListItem>
          <ListItem>
            <i>Applicable Law:</i> This Agreement and the rights and obligations
            hereunder shall be interpreted, construed and governed by the laws
            of India.
          </ListItem>
          <ListItem>
            <i>Dispute Resolution and Jurisdiction:</i> Any dispute, difference
            or controversy of whatsoever nature, howsoever arising out of or in
            relation to this Agreement (including its interpretation or
            application) between the Parties (“Dispute”) shall, in the first
            instance, be dealt with, at the request of either of the Parties, by
            amicable negotiations between the representative of each Party. The
            Parties agree to use their best efforts for resolving all Disputes
            arising under or in relation to this Agreement promptly, equitably
            and in good faith. Any Dispute which is not resolved by amicable
            negotiations as provided hereinabove within 45 (forty-five) days of
            the date when such negotiations were requested by either Party,
            shall be referred to and resolved by way of arbitration, adjudicated
            by a sole arbitrator appointed mutually by the Parties and in
            accordance with the Arbitration & Conciliation Act, 1996 (including
            any amendment, modification and/or re-enactment thereof and which
            rules are deemed to be incorporated in this Agreement by reference
            herein). The arbitration proceedings shall be conducted in English
            language. The seat and venue of Arbitration shall be Delhi. The
            arbitral award shall be substantiated in writing and the costs of
            arbitration proceedings shall be shared between the Parties in equal
            proportion. Subject to the foregoing, the Parties hereby agree to
            submit to the exclusive jurisdiction of the courts in New Delhi
          </ListItem>
          <ListItem>
            <i>Survival:</i> Any provisions of this Agreement which expressly or
            by their nature need to survive termination or expiration shall
            survive termination or expiration of this Agreement.
          </ListItem>
          <ListItem>
            <i>Notices:</i> All notice, requests, demands and other
            communications hereunder shall be in English and shall be given in
            writing and shall be either: (a) personally delivered; (b) sent by
            telecopier, facsimile transmission or other electronic means of
            transmitting written documents with confirmation of receipt; or (c)
            sent to the Parties at their respective addresses indicated herein
            by registered or certified mail, return receipt requested and
            postage prepaid, or by private overnight mail courier services with
            confirmation of receipt. All notices shall be given by the Service
            Provider to the Participant: (i) by electronic mail to the
            electronic mail address provided by the Participant to the Service
            Provider; or (ii) by WhatsApp / SMS to the registered mobile number
            provided by the Participant. Any notices, demands or requests by the
            Participant shall be sent to the Service Provider by speed
            post/courier at S-436, Basement, Greater Kailash, Part – 1, South
            Delhi, New Delhi, Delhi, India 110048 or through electronic mail at
            info@cloudcayr.com
          </ListItem>
        </ul>
      </li>
    </ol>
  </div>
);

export default Agreement;
